/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { InitiativePlain, Materiality } from '../types/initiative';
import { AssessmentType } from '../types/survey';

export const MaterialityTitle = {
  [Materiality.Low]: 'Low Materiality',
  [Materiality.Medium]: 'Medium Materiality',
  [Materiality.High]: 'High Materiality',
  [Materiality.None]: 'No Materiality',
}

export const hasMateriality = (materiality: InitiativePlain['materiality']) => {
  if (!materiality) {
    return false;
  }
  return Object.values(materiality).some(value => value > 0);
}

export const assessmentTypeLabels: Record<string, string> = {
  [AssessmentType.FinancialMateriality]: 'Financial materiality assessment',
  [AssessmentType.DoubleMateriality]: 'Double materiality assessment',
};
